import clsx from 'clsx';
import {useRef, useState} from 'react';

import {useNotifications} from '@/providers/components/notificationsProvider';

import Icon from '@/components/icon';

type SearchBarProps = {
  className?: string;
};

export function SearchBar({className = ''}: SearchBarProps) {
  const {searchQuery, setSearchQuery} = useNotifications();

  // Refs
  const inputRef = useRef<HTMLInputElement>(null);

  // State
  const [showClearButton, setShowClearButton] = useState(false);

  // Functions
  const handleClear = () => {
    setSearchQuery('');
    setShowClearButton(false);
    inputRef.current?.focus();
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchQuery(e.target.value);
    setShowClearButton(e.target.value.length > 0);
  };

  return (
    <div className={clsx('relative flex items-stretch gap-4', className)}>
      <div className="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3">
        <Icon name="search" />
      </div>
      <input
        ref={inputRef}
        type="text"
        value={searchQuery}
        onChange={handleChange}
        placeholder="Search notifications..."
        className="block w-full rounded-md bg-gray-700/50 pl-10 pr-3 text-sm text-gray-200 placeholder-gray-400 focus:outline-none focus:ring-1 focus:ring-primary"
      />
      {showClearButton && (
        <button type="button" className="absolute right-0 top-0 h-full w-10" onClick={handleClear}>
          <Icon name="x" />
        </button>
      )}
    </div>
  );
}
